export default __webpack_public_path__ + "img/searching.dfa8749a.gif";